/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Helmet from 'react-helmet';
/* eslint-enable import/no-extraneous-dependencies */
import MayurProfile from '../../assets/mayur-profile.png';
import MadhurProfile from '../../assets/madhur-profile.png';


import Hero from '../components/hero';
import About from '../pageComponents/about';

import styles from '../pageComponents/card.module.css';

export default () => ([
  <Helmet key="aboutHelmet" title="YesWeAreTwins" />,
  <Hero color="green" gradient key="aboutHero">
    About us
  </Hero>,
  <About key="aboutDetails" />,
]);



// WEBPACK FOOTER //
// ./src/pages/about.jsx